export const isString = (v): v is string => v !== null;
export const isNumber = (v): v is number => v !== null;
